import { inject, Pipe, type PipeTransform } from '@angular/core';
import { isDate, isValid } from 'date-fns';
import { DateFormattingService } from '../services/date-formatting.service';

@Pipe({
  name: 'rcpWordedDate',
})
export class RcpWordedDatePipe implements PipeTransform {
  private dateFormattingService = inject(DateFormattingService);

  transform(dateInput: string | Date | null | undefined, format = 'EEEE d MMMM yyyy'): string | null {
    if (!dateInput || (isDate(dateInput) && !isValid(dateInput))) {
      return null;
    }
    return this.dateFormattingService.wordedDate(dateInput, format);
  }
}
